<template>
  <div class="text-center">
    <v-dialog width="500" :value="showDialog">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Make another request?</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('returnToOverview')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="text-xs-center">
          <v-btn block class="mb-4" @click="$emit('anotherRequest')">Make another request</v-btn>
          <v-btn block class="mb-4" @click="$emit('returnToOverview')">Back to overview</v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: ['showDialog'],
    data () {
      return {
        url: this.$store.getters.url,
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        dateConfirmed: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AnotherHolidayRequestDialog.vue